import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/cms/ui/dialog";
import { UIVideoUpload } from "@/components/cms/ui/ui-video-upload";
import { UIImageCategory, UI_IMAGE_CATEGORIES } from "@/modules/uiImages/types";

interface UIVideoUploadDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onVideoSelect: (videoUrl: string) => void;
  currentVideo?: string;
  title?: string;
  description?: string;
  imageCategory: UIImageCategory;
  contextId?: string;
}

export function UIVideoUploadDialog({
  open,
  onOpenChange,
  onVideoSelect,
  currentVideo,
  title,
  description,
  imageCategory,
  contextId
}: UIVideoUploadDialogProps) {
  const categoryConfig = UI_IMAGE_CATEGORIES[imageCategory];

  const defaultTitle = title || `Upload ${imageCategory}`;
  const defaultDescription = description || `Select a video for ${categoryConfig.description.toLowerCase()}. Maximum file size is ${categoryConfig.maxSizeMB || 500}MB.`;

  const handleVideoSelect = (videoUrl: string) => {
    onVideoSelect(videoUrl);
    // Close when a non-empty video is selected
    if (videoUrl && videoUrl.trim() !== '') {
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent width="lg" className="cursor-default select-none">
        <DialogHeader>
          <DialogTitle>{defaultTitle}</DialogTitle>
          <DialogDescription>{defaultDescription}</DialogDescription>
        </DialogHeader>

        <DialogBody className="min-h-40">
          <UIVideoUpload
            onVideoSelect={handleVideoSelect}
            currentVideo={currentVideo}
            maxSizeInMB={categoryConfig.maxSizeMB || 500}
            contextId={contextId}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}

